/**
* Volta Financial Service
* Volta is the Oi Soft ERP
*
* OpenAPI spec version: v1
*
*
* NOTE: This class is auto generated by swagger-codegen-calls.py.
* Do not edit the class manually.
*/
import { Injectable } from '@angular/core';
import { VoltaApiService } from '@core/api/volta.api.service'
import { RequestOptions, RequestOptionsWithoutBody } from "node_modules/@oi-soft/common/public-api";
import { ProcessRunnerAssetRegisterBulkUploadGetParameters } from '@api/model/processRunnerAssetRegisterBulkUploadGetParameters';
import { ProcessRunnerAssetRegisterBulkUploadPostParameters } from '@api/model/processRunnerAssetRegisterBulkUploadPostParameters';
import { ProcessRunnerAssetRegisterDepreciationPostParameters } from '@api/model/processRunnerAssetRegisterDepreciationPostParameters';

@Injectable({
    providedIn: 'root'
})
export class ProcessRunnerApiService extends VoltaApiService {

    private path = `${this.API_URL}/process-runner`;

    ProcessRunner = {

		AssetRegister: {

			BulkUpload: {

				Get:(request?:RequestOptionsWithoutBody<ProcessRunnerAssetRegisterBulkUploadGetParameters>) =>
					this.get<Blob>(`${this.path}/asset-register/bulk-upload`, request),

				Post:(request?:RequestOptions<FormData, ProcessRunnerAssetRegisterBulkUploadPostParameters>) =>
					this.post<boolean>(`${this.path}/asset-register/bulk-upload`, request),

			},

			Depreciation: {

				Post:(request?:RequestOptionsWithoutBody<ProcessRunnerAssetRegisterDepreciationPostParameters>) =>
					this.post<boolean>(`${this.path}/asset-register/depreciation`, request),

			},

		},

	}
}